module.exports = __webpack_public_path__ + "static/media/desistir.2080ac47.png";